import http from "@/http";
// ### 计划任务日志
// http://base.leubao.com/api/cron/cron_log
export const getCronLogist = {
  p: "/api/cron/cron_log",
  r: data => {
    return http({
      url: "/api/cron/cron_log",
      method: "post",
      data
    });
  }
};
